import { intakeQuestionDataByCodes, renderQuestionTitle } from "~/common/utils";
import { removeDot } from "~/common/utils/removeDot";
import { DirectInquiryQuestions } from "~/providers/utils/types/patientIntakePreviewTypes";

interface RenderDirectQuestionsProps {
  directInquiryQuestions?: DirectInquiryQuestions[];
}

export const RenderDirectQuestions = ({
  directInquiryQuestions,
}: RenderDirectQuestionsProps) => {
  if (!directInquiryQuestions) return <p>None</p>;

  return directInquiryQuestions.map((question) => {
    const answer = question.answer;
    const questionData = intakeQuestionDataByCodes[question.question_code];
    const questionTitle = renderQuestionTitle(questionData.title);
    return (
      <div key={question.question_code}>
        <p>
          {questionTitle && removeDot(questionTitle)}:{" "}
          <span className="font-semibold">{answer?.value}</span>
        </p>
      </div>
    );
  });
};
